<template>
  <div class="yu-head">
    <div class="container">
      <ul>
        <li>
          <i class="iconfont icon-yuren"></i>
        </li>
        <li>
          <img class="yumobile" :src="yumobile" alt="">
        </li>
        <li>
          一套简洁，小巧的基于 Vue 2.0 的移动端组件库
        </li>
        <li>
          扫二维码查看Demo
        </li>
        <li class="qrcodeBox">
          <i class="iconfont icon-qrcode" style="font-size: 30px"></i>
          <div class="qrcode"><img :src="qrcode"></div>
        </li>
        <li class="active">使用文档 {{version}}</li>
      </ul>
    </div>
  </div>
</template>

<script>
import { version } from 'yu.mobile';
import qrcode from '../assets/qrcode.png';
import yumobile from '../assets/yu-mobile.png';

export default {
  name: 'YuMenu',
  data() {
    return {
      version,
      qrcode,
      yumobile,
    }
  },
};
</script>

<style lang="scss" scoped type="text/scss">
  @import "../assets/css/varible";

  .yu-head {
    font-size: $big;
    width: 100%;
    height: 64px;
    background-color: $main;
    box-sizing: border-box;
    box-shadow: $box-shadow;
    .container {
      width: 1200px;
      margin: 0 auto;
      height: 64px;
      ul {
        margin: 0;

      }
      ul li {
        vertical-align: top;
        display: inline-block;
        height: 64px;
        padding: 0 20px;
        line-height: 64px;
        text-align: center;
        list-style: none;
        color: #eee;
        .icon-yuren {
          font-size: 50px;
        }
        &:nth-child(1) img {
          vertical-align: middle;
          width: 50px;
        }
        &.active {
          background-color: lighten($main, 6);
          color: #fff;
        }
        a {
          color: #fff;
          text-decoration: none;
        }
        .yumobile{
          width: 140px;
          margin-top: 10px;
        }
        &.qrcodeBox {
          &:hover {
            .qrcode {
              display: block;
            }
          }
          position: relative;
          .qrcode {
            display: none;
            position: absolute;
            top: 70px;
            right: -80px;
            background-color: #fff;
            box-shadow: $box-shadow;
            border-radius: 4px;
            padding: 8px;
            font-size: 0;
            height: 200px;
            img {
              width: 200px;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/yu-head.vue